<template>
  <div
    class="bg-gradient-to-br from-linear-s to-linear-e h-full flex flex-col justify-start items-center pt-12 gap-y-8 p-6"
  >
    <div class="w-full flex flex-col gap-y-3 border-b border-white pb-5">
      <h3 class="text text-white text-center">{{ $t('fontSize') }}</h3>
      <div class="w-full flex gap-x-4 justify-center items-stretch">
        <button
          class="border-2 border-white rounded px-3 py-1 text-xl disabled:text-gray-500"
          @click="themeStore.modifyBaseRem(-1)"
        >
          A-
        </button>
        <button
          class="border-2 border-white rounded px-3 py-1 text-2xl disabled:text-gray-500"
          @click="themeStore.modifyBaseRem(1)"
        >
          A+
        </button>
      </div>
    </div>
    <div class="w-full flex flex-col gap-y-3 border-b border-white pb-5">
      <h3 class="text text-white text-center">{{ $t('theme') }}</h3>
      <div class="w-full flex gap-x-4 justify-center items-stretch">
        <button
          class="border-2 border-white rounded px-3 py-2 text-xl disabled:text-gray-500"
          @click="toggleTheme()"
        >
          <faSunIcon v-if="isLight" class="w-6" />
          <faMoonIcon v-else class="w-5" />
        </button>
      </div>
    </div>
    <div class="w-full flex flex-col gap-y-3 border-b border-white pb-5">
      <h3 class="text text-white text-center">{{ $t('chooseColor') }}</h3>
      <div class="w-full flex gap-x-4 justify-center items-stretch">
        <button
          v-for="(theme, key) in themeStore.themes"
          :key="key"
          :data-theme="theme"
          :class="themeStore.currentTheme == theme ? 'border-2 border-white' : 'border-gray-200'"
          class="w-8 h-8 rounded-full p-[1px]"
          @click="themeStore.selectTheme(theme)"
        >
          <div class="w-full h-full rounded-full bg-primary"></div>
        </button>
      </div>
    </div>
  </div>
</template>

<script setup>
import { useThemeStore } from '@/stores/theme'
import faSunIcon from '@/assets/icons/faSun.svg?component'
import faMoonIcon from '@/assets/icons/faMoon.svg?component'

import { useToggle } from '@vueuse/core'
import { watch } from 'vue'

const themeStore = useThemeStore()

const [isLight, toggleTheme] = useToggle(document.body.classList.contains('light'))

watch(isLight, () => {
  const newScheme = isLight.value ? 'light' : 'dark'
  themeStore.setColorScheme(newScheme)
})
</script>

<style lang="scss" scoped></style>
